import { render, staticRenderFns } from "./acceptanceTable.vue?vue&type=template&id=4bdf1072&scoped=true"
import script from "./acceptanceTable.vue?vue&type=script&lang=js"
export * from "./acceptanceTable.vue?vue&type=script&lang=js"
import style0 from "./acceptanceTable.vue?vue&type=style&index=0&id=4bdf1072&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf1072",
  null
  
)

export default component.exports